import React, { FC, useContext } from "react";
import DateFnsUtils from "@date-io/date-fns";
import { Collapse, FormControl, FormLabel, Grid } from "@material-ui/core";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { FiltersContext, VisibilityContext } from "../../context";
import { format } from "../../functions";

const useStyles = makeStyles((theme: Theme) => ({
  legend: {
    marginBottom: "0.6rem",
  },
  picker: {
    marginTop: 0,
    borderRadius: "7%",
    backgroundColor: theme.palette.background.paper,
  },
}));

interface DatePickersProps {
  label: string;
  visibilitySection: string;
}

const DatePickers: FC<DatePickersProps> = ({ label, visibilitySection }) => {
  const classes = useStyles();

  const [filtersContext, setFiltersContext] = useContext(FiltersContext);
  const [visibilityContext, setVisibilityContext] = useContext(VisibilityContext);

  const setFilters = (filter: string, value: string) => {
    setFiltersContext({
      ...filtersContext,
      [filter]: [value],
    });
  };

  const handleDateFromChange = (date: Date | null) => {
    if (date === null) return;
    const fromDateStr = `From: ${format.dateToStr(date.toISOString(), "MM/dd/yyyy")}`;
    setFilters("dateFrom", fromDateStr);
  };

  const handleDateToChange = (date: Date | null) => {
    if (date === null) return;
    const toDateStr = `To: ${format.dateToStr(date.toISOString(), "MM/dd/yyyy")}`;
    setFilters("dateTo", toDateStr);
  };

  return (
    <Collapse in={visibilityContext[visibilitySection]}>
      <FormControl component="fieldset" fullWidth margin="dense">
        <FormLabel component="legend" className={classes.legend}>
          {label}
        </FormLabel>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container justify="space-around">
            <Grid item xs={12}>
              <KeyboardDatePicker
                clearable
                size="small"
                disableToolbar
                inputVariant="outlined"
                format="MM/dd/yyyy"
                margin="normal"
                id="date-from"
                label="From"
                className={classes.picker}
                value={filtersContext["dateFrom"][0] || null}
                onChange={handleDateFromChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <KeyboardDatePicker
                clearable
                size="small"
                disableToolbar
                inputVariant="outlined"
                format="MM/dd/yyyy"
                margin="normal"
                id="date-to"
                label="To"
                className={classes.picker}
                value={filtersContext["dateTo"][0] || null}
                onChange={handleDateToChange}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </Grid>
          </Grid>
        </MuiPickersUtilsProvider>
      </FormControl>
    </Collapse>
  );
};

export default DatePickers;
